export default [
  {
    title:
      "DeepTC-Enhancer: Improving the Readability of Automatically Generated Tests",
    authors: [""],
    link:
      "http://veneraarnaoudova.com/wp-content/uploads/2020/09/2020-ASE-PREPRINT-DeepTC-Enhancer-Improving-the-Readability-of-Automatically-Generated-Tests.pdf",
    venue: "International Conference on Automated Software Engineering (ASE)",
    year: 2020,
  },
  {
    title:
      "A model to detect incremental readability improvements in incremental changes",
    authors: ["Devjeet Roy", "Sarah Fakhoury", "John Lee", "Venera Arnaoudova"],
    link:
      "http://veneraarnaoudova.com/wp-content/uploads/2020/07/2020-ICPC-PREPRINT-A-Model-to-Detect-Readability-Improvements-in-Incremental-Changes.pdf",
    venue:
      "Proceedings of the International Conference on Program Comprehension (ICPC)",
    year: 2020,
  },
  {
    title: "VITALSE: Visualizing Eye Tracking and Biometric Data",
    authors: ["Devjeet Roy", "Sarah Fakhoury", "Venera Arnaoudova"],
    link:
      "http://veneraarnaoudova.com/wp-content/uploads/2020/02/2020-ICSE_Tool-PREPRINT-VITALSE-Visualizing-Eye-Tracking-and-Biometric-Data.pdf",
    venue:
      "Proceedings of the International Conference on Software Engineering (ICSE) - Demonstrations Track",
    year: 2020,
  },
  {
    title: "Improving Source Code Readability: Theory and Practice",
    authors: [
      "Sarah Fakhoury",
      "Devjeet Roy",
      "Sk. Adnan Hassan",
      "Venera Arnaoudova",
    ],
    link: "https://sarahfakhoury.com/2019-icpc-readability.pdf",
    venue:
      "(Inproceeding) Proceedings of the International Conference on Program Comprehension (ICPC)",
    year: 2019,
  },
  {
    title:
      "Measuring the impact of lexical and structural inconsistencies on developers’ cognitive load during bug localization",
    authors: [
      "Sarah Fakhoury",
      "Devjeet Roy",
      "Yuzhan Ma",
      "Venera Arnaoudova",
      "Olusola Adesope",
    ],
    link:
      "https://sarahfakhoury.com/2019-EMSE-Impact-Lexical-Structural-Inconsistencies-Cognitive-Load-Bug-Localization.pdf",
    venue: "Empirical Software Engineering (EMSE), 24",
    year: 2019,
  },
];
